/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InterviewBookingTokenStoreRequest,
	InterviewBookingTokenStoreResponse,
} from '../types/InterviewBookingTokenStore'

/**
 * POST /interview-scheduling/tokens
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/InterviewBookingTokenController.php InterviewBookingTokenController::store
 */
export async function interviewBookingTokenStore(
	data: InterviewBookingTokenStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InterviewBookingTokenStoreResponse>> {
	return axiosInstance.post('/interview-scheduling/tokens', data, config)
}
